import React, { isValidElement } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Tooltip from '@mui/material/Tooltip';

const DataDisplayItem = ({ additionalStackStyling, icon, label, tooltip, value, valueVariant }) => (
  <Stack spacing={1} sx={{ ...additionalStackStyling }}>
    <Stack alignItems="center" direction="row" spacing={0.5}>
      <Typography variant="caption">{label}</Typography>
      <Tooltip placement="top" title={tooltip}>
        <Typography
          sx={{
            display: 'inline-block',
            fontSize: 10,
            mb: '-8px!important',
            mt: '-8px!important',
          }}
          variant="caption"
        >
          {icon}
        </Typography>
      </Tooltip>
    </Stack>
    {isValidElement(value) ? (
      value
    ) : (
      <Typography sx={{ marginTop: 'auto', wordBreak: 'break-word' }} variant={valueVariant}>
        {R.or(R.isEmpty(value), R.isNil(value)) ? '--' : value}
      </Typography>
    )}
  </Stack>
);

DataDisplayItem.propTypes = {
  additionalStackStyling: PropTypes.shape({}),
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  value: PropTypes.node,
  valueVariant: PropTypes.string,
};

DataDisplayItem.defaultProps = {
  additionalStackStyling: null,
  icon: null,
  tooltip: '',
  value: null,
  valueVariant: 'body1bold',
};

export default DataDisplayItem;
